export const COUNTRY_CODES = [
    { name: 'Argentina', code: '+54' },
    { name: 'Belize', code: '+501' },
    { name: 'Bolivia', code: '+591' },
    { name: 'Brazil', code: '+55' },
    { name: 'Canada', code: '+1' },
    { name: 'Chile', code: '+56' },
    { name: 'Colombia', code: '+57' },
    { name: 'Costa Rica', code: '+506' },
    { name: 'Cuba', code: '+53' },
    { name: 'Ecuador', code: '+593' },
    { name: 'El Salvador', code: '+503' },
    { name: 'Guatemala', code: '+502' },
    { name: 'Guyana', code: '+592' },
    { name: 'Haiti', code: '+509' },
    { name: 'Honduras', code: '+504' },
    { name: 'Jamaica', code: '+1-876' },
    { name: 'Mexico', code: '+52' },
    { name: 'Nicaragua', code: '+505' },
    { name: 'Panama', code: '+507' },
    { name: 'Paraguay', code: '+595' },
    { name: 'Peru', code: '+51' },
    { name: 'Suriname', code: '+597' },
    { name: 'United States', code: '+1' },
    { name: 'Uruguay', code: '+598' },
    { name: 'Venezuela', code: '+58' }
];
